export function createFadeInStyles(index = 0) {
  return {
    animation: 'fadeIn .5s',
    animationDuration: `${index * 0.5}s`,
  };
}
